import { GetTen99PolicyAssignmentByShiftIdResponseSchema } from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";
import { isEmpty } from "lodash";

import { type GetTen99PolicyAssignmentByShiftIdResponse } from "./schema";

export function getAssignmentByShiftIdPath(shiftId: string) {
  return `/shifts/${shiftId}/1099-policy/assignments`;
}

export function useGetAssignmentByShiftId(
  shiftId: string,
  options: UseGetQueryOptions<GetTen99PolicyAssignmentByShiftIdResponse> = {}
): UseQueryResult<GetTen99PolicyAssignmentByShiftIdResponse> {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}${getAssignmentByShiftIdPath(shiftId)}`,
    responseSchema: GetTen99PolicyAssignmentByShiftIdResponseSchema,
    enabled: isDefined(shiftId) && !isEmpty(shiftId) && (options.enabled ?? true),
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_TEN99_POLICY_ASSIGNMENT_BY_SHIFT_ID_FAILURE,
    },
    ...options,
  });
}
